import { useEffect, useReducer, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { listAction as categoryListAction } from "../../network/store/action/CategoryResponseAction";
import { listAction as subCategoryListAction } from "../../network/store/action/SubCategoryResponseAction";
import { ToastContainer, toast } from "react-toastify";

import "./products.css";
import {
  formUpdateData,
  formUpdateStatus,
  updateFormInfo,
} from "../../redux/slice/formUpdateSlice";
import { useNavigate } from "react-router-dom";
import { updateMessage } from "../../redux/slice/toastSlice";
import AppToast from "../../components/appToast";
import {
  createUpdateAction,
  tagUpdateAction,
  taglistAction,
} from "../../network/store/action/ProductResponseAction";
import SelectableTagItem from "./selectable-tag-item";
import {
  onClearData,
  selectedItemsStatus,
} from "../../redux/slice/selectedItemsSlice";
import axios from "axios";
import { API_CONFIG, API_HEADERS } from "../../network/config/ApiConfig";
import { TAG_API_PATH } from "../../network/config/apiPaths";
import { consoleLog } from "../../utils/log-utils";
import { useToastMsg, useToastMsgWithOutFun } from "../hooks/useToastMsg";

function ProductTagUpdate() {
  // to get api data

  const dispatch = useDispatch();
  const showRequestForm = useSelector(formUpdateStatus);
  const formData = useSelector(formUpdateData);
  const itemInfo = formData.product;
  // list of items
  const [resultList, setResultList] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [productId, setProductId] = useState("");
  const selectedIds = useSelector(selectedItemsStatus);
  const navigate = useNavigate();
  useEffect(() => {
    if (itemInfo != undefined) {
      setProductId(itemInfo.id);
      loadData(itemInfo.id);
    }
  }, []);

  // useEffect(() => {

  // }, [productId]);

  const [success,warning]=useToastMsgWithOutFun("Tags cleared","Something Wrong");

  const loadData = async (productId) => {
    setLoading(true);
    await dispatch(taglistAction({ productId: productId }, dispatch)).then(
      (response) => {
        setLoading(false);
        if (response.result) {
          setResultList(response.result);
        }
      }
    );
  };
 
  const clearTags=async () =>{
    // setIsLoading(true)
    const data=await axios.get(API_CONFIG.API_HOST+ TAG_API_PATH.PRODUCT_TAG_DELETE +`?productId=${itemInfo.id}`,{
      headers:API_HEADERS,
    })
    
    
    consoleLog("data....",data)
    // setIsLoading(false)
    if(data.data.status){
    //  window.alert("Tags cleared.")
    //   navigate(-1)
    success()
    }
    
  }
  const onUpdateClick = async () => {
    if (selectedIds && selectedIds.length > 0) {
      let itemObj = {
        productId: productId,
        tagIds: selectedIds.toString(),
      };

      await dispatch(tagUpdateAction(itemObj, dispatch)).then((response) => {
       
        consoleLog("createUpdateAction", response.result)
        if (response.result) {
          dispatch(
            updateMessage({
              display: true,
              message: "Product Created.",
            })
          );
          dispatch(onClearData());
          navigate(-1);
        }
      });
    } else {
      dispatch(
        updateMessage({
          display: true,
          message: "Select Tags",
        })
      );
    }
  };

  return (
    <>
      <AppToast />
      <ToastContainer />
      <main className="container-fluid dashboard">
        <div
          className="row justify-content-around tble"
          style={{ padding: "20px" }}
        >
          <div className="col-6">
            <h3 className="dashboard-title">Product Tags</h3>
          </div>
          <div className="mr-auto col-6 text-end">
            <button
              type="button"
              className="mr-auto btn btn-purple-bg"
              onClick={() => {
                onUpdateClick();
              }}
            >
              Update
            </button>

            <button
              type="button"
              className="mr-auto btn "
              onClick={() => {
                clearTags()
              }}
            >
              Clear Tags
            </button>
            <button
              type="button"
              className="mr-auto btn btn-danger "
              onClick={() => {
                navigate(-1)
              }}
            >
              close
            </button>
          </div>
        </div>

        {resultList && resultList.length > 0 ? (
          <div className="col-md-12" style={{ padding: "20px" }}>
            {resultList.map((item, i) => {
              return (
                <SelectableTagItem
                  item={item}
                  key={item.id}
                  itemStatus={item.productTagId === "NO" ? false : true}
                />
              );
            })}
          </div>
        ) : isLoading ? (
          <p>Loading Tags</p>
        ) : (
          <p>No Data found</p>
        )}
      </main>
    </>
  );
}
export default ProductTagUpdate;
